module.exports = __webpack_public_path__ + "img/registrate-completa.c577ac78.png";